import React from "react";
import { Modal, Fade, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";

function ModalImage(props) {
  const { open, url, onClose, onButtonClick, buttonLabel, loading } = props;

  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
          backgroundcolor: "red",
        },
      }}
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <>
        <Fade in={open} timeout={500} sx={{ outile: "none" }}>
          <img
            src={url}
            alt={url}
            style={{ maxHeight: "90%", maxWidth: "90%" }}
          />
        </Fade>
        {buttonLabel && (
          <Fade
            in={open}
            timeout={500}
            sx={{
              outile: "none",
              position: "absolute",
              bottom: 60,
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Box>
              <LoadingButton
                variant="contained"
                size="large"
                onClick={onButtonClick}
                loading={loading}
              >
                {buttonLabel}
              </LoadingButton>
            </Box>
          </Fade>
        )}
      </>
    </Modal>
  );
}

export default ModalImage;
